<section class="flex flex-col items-center gap-6">
  <h1 class="text-4xl font-bold md:text-5xl">iOS UDID Finder</h1>
  <p class="text-xl font-semibold">Find Your iPhone or iPad UDID Instantly</p>
  <p class="max-w-3xl text-balance text-center text-lg">
    Get your device UDID without a Mac or Xcode. Install a lightweight
    configuration profile on your iOS device and retrieve your UDID, serial
    number, and more in seconds.
  </p>
  @defer {
    @if (isMobile) {
      <a
        iconEnd="@tui.arrow-right"
        size="l"
        tuiButton
        [href]="profileUrl"
        data-umami-event="tools-ios-udid-finder-hero-find-udid-button"
      >
        Find My UDID
      </a>
    } @else {
      <p class="text-lg">Scan this QR code with your iPhone or iPad:</p>
      <img
        [src]="qrCodeUrl"
        alt="QR code to find your iOS device UDID"
        class="h-48 w-48"
      />
    }
  } @placeholder {
    <div class="h-12 w-32 animate-pulse rounded-xl bg-gray-200"></div>
  }
  <div class="mt-4 flex w-full flex-col gap-4 md:w-2/3 lg:w-1/2">
    <h2 class="text-xl font-bold">How It Works</h2>
    <ol class="flex list-inside list-decimal flex-col gap-3 text-lg">
      @defer {
        @if (isMobile) {
          <li>
            Tap
            <strong>"Find My UDID"</strong>
            and allow the profile download.
          </li>
        } @else {
          <li>
            Scan the
            <strong>QR code</strong>
            above with your iOS device and allow the profile download.
          </li>
        }
      } @placeholder {
        <li class="animate-pulse">
          <span class="inline-block h-4 w-64 rounded bg-gray-200"></span>
        </li>
      }
      <li>
        Open the
        <strong>Settings</strong>
        app on your device.
      </li>
      <li>
        Tap
        <strong>"Profile Downloaded"</strong>
        near the top.
      </li>
      <li>
        Tap
        <strong>Install</strong>
        and follow the prompts.
      </li>
      <li>You will be redirected back with your device information.</li>
    </ol>
  </div>
</section>
